"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMappedOrderOptions = exports.getMappedAddress = void 0;
const enums_1 = require("./enums");
function getMappedAddress(mappings) {
    const address = {
        company: getValue(mappings, enums_1.FormToolField.Company),
        salutation: getValue(mappings, enums_1.FormToolField.Salutation),
        title: getValue(mappings, enums_1.FormToolField.Title),
        firstName: getValue(mappings, enums_1.FormToolField.FirstName),
        name: getValue(mappings, enums_1.FormToolField.LastName),
        function: getValue(mappings, enums_1.FormToolField.Function),
        street: getValue(mappings, enums_1.FormToolField.Street),
        postCode: getValue(mappings, enums_1.FormToolField.PostalCode),
        city: getValue(mappings, enums_1.FormToolField.City),
        telephone: getValue(mappings, enums_1.FormToolField.TelephoneNumber),
        email: getValue(mappings, enums_1.FormToolField.Email),
        countryId: parseInt(getValue(mappings, enums_1.FormToolField.Country)),
        deliverySalutation: getValue(mappings, enums_1.FormToolField.DeliverySalutation),
        deliveryFirstName: getValue(mappings, enums_1.FormToolField.DeliveryFirstName),
        deliveryLastName: getValue(mappings, enums_1.FormToolField.DeliveryLastName),
        deliveryCompanyName: getValue(mappings, enums_1.FormToolField.DeliveryCompany),
        deliveryStreet: getValue(mappings, enums_1.FormToolField.DeliveryStreet),
        deliveryPostCode: getValue(mappings, enums_1.FormToolField.DeliveryPostalCode),
        deliveryCity: getValue(mappings, enums_1.FormToolField.City),
        deliveryCountryId: parseInt(getValue(mappings, enums_1.FormToolField.DeliveryCountry)) || null,
    };
    return address;
}
exports.getMappedAddress = getMappedAddress;
function getMappedOrderOptions(id, orderId, mappings) {
    const orderOptions = {
        id: id,
        orderId: orderId,
        option1: getValue(mappings, enums_1.FormToolField.Option1),
        option2: getValue(mappings, enums_1.FormToolField.Option2),
        option3: getValue(mappings, enums_1.FormToolField.Option3),
        option4: getValue(mappings, enums_1.FormToolField.Option4),
        option5: getValue(mappings, enums_1.FormToolField.Option5),
        option6: getValue(mappings, enums_1.FormToolField.Option6),
        option7: getValue(mappings, enums_1.FormToolField.Option7),
        option8: getValue(mappings, enums_1.FormToolField.Option8),
        option9: getValue(mappings, enums_1.FormToolField.Option9),
        option10: getValue(mappings, enums_1.FormToolField.Option10),
        option11: getValue(mappings, enums_1.FormToolField.Option11),
        option12: getValue(mappings, enums_1.FormToolField.Option12),
        option13: getValue(mappings, enums_1.FormToolField.Option13),
        option14: getValue(mappings, enums_1.FormToolField.Option14),
        option15: getValue(mappings, enums_1.FormToolField.Option15),
        option16: getValue(mappings, enums_1.FormToolField.Option16),
        option17: getValue(mappings, enums_1.FormToolField.Option17),
        option18: getValue(mappings, enums_1.FormToolField.Option18),
        option19: getValue(mappings, enums_1.FormToolField.Option19),
        option20: getValue(mappings, enums_1.FormToolField.Option20)
    };
    return orderOptions;
}
exports.getMappedOrderOptions = getMappedOrderOptions;
function getValue(mappings, formToolField) {
    var _a, _b;
    return (_b = (_a = mappings.find(m => m.id === formToolField)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
}
